<template>
  <vx-card class="overflow-hidden" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <div>
      <vs-button type="border" class="ml-5" @click="show()">Etiketleri Göster</vs-button>
      <vs-button type="border" class="ml-5" @click="addTags()">Etiket Ekle</vs-button>
      <vs-popup title="Ekle" :active.sync="popupActivo">
        <div class="mt-5">
          <label class="mr-2">
            <b>Etiket</b>
          </label>
          <vs-input type="text" class="w-full" v-model="value" />
        </div>
        <div class="wx-col mt-5 flex justify-end">
          <vs-button class="wx-row ml-10" color="warning" icon-pack="feather" @click="save()">Kaydet</vs-button>
        </div>
      </vs-popup>
      <vs-popup title="Güncelle" :active.sync="editPopupActivo">
        <div class="mt-5">
          <label class="mr-2">
            <b>Etiket</b>
          </label>
          <vs-input name="value" class="w-full" v-model="tagToBeEdited.value" />
        </div>
        <div class="wx-col mt-5 flex justify-end">
          <vs-button
            class="wx-row ml-10"
            color="warning"
            icon-pack="feather"
            @click="saveChanges()"
          >Güncelle</vs-button>
        </div>
      </vs-popup>
      <vs-table
        search
        noDataText="Etiket Bulunamadı!"
        :data="customerTags"
        class="w-full"
        :pagination="true"
        :maxItems="8"
      >
        <template slot="thead">
          <vs-th>Etiket</vs-th>
          <vs-th>İşlemler</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, i) in data" :key="i">
            <vs-td style="width:50px">{{ tr.value}}</vs-td>
            <vs-td style="width:50px" class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                title="Etiket Düzenle"
                class="ml-2 hoverZoom"
                svgClasses="w-6 h-6 hover:text-dark stroke-current"
                @click="editTags(tr)" 
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </vx-card>
</template>
<script>
import { repository } from "@/_services/repository.js";
export default {
  components: {},
  data() {
    return {
      tagToBeEdited: {
        id: -1,
        value: ""
      },
      customerTags: [],
      popupActivo: false,
      editPopupActivo: false,
      value: ""
    };
  },
  methods: {
    save: async function() {
      if (!this.value) {
        this.$vs.notify({
          title: "Hata",
          text: "Lütfen etiket ismi giriniz",
          color: "danger"
        });
        return;
      }
      let postModel = {
        value: this.value.toString()
      };
      let r = await repository.postEntity("Customer/createTag", postModel);
      if (r && !r.hasExceptionError) {
        this.$vs.notify({
          title: "Başarılı",
          text: "Ekleme İşlemi Tamamlandı",
          color: "success"
        });
        //success
      } else {
        this.$vs.notify({
          title: "Hata",
          text: (r && r.exceptionMessage) || "Bilinmeyen hata",
          color: "warning"
        });

        //mesajı göster;
      }

      this.value = "";
      this.popupActivo = false;
    },
    saveChanges: async function() {
      let r = await repository.postEntity(
        "Customer/editTag",
        this.tagToBeEdited
      );

      if (r && !r.hasExceptionError) {
        this.$vs.notify({
          title: "Başarılı",
          text: "Düzenleme İşlemi Tamamlandı",
          color: "success"
        });
        //success
      } else {
        this.$vs.notify({
          title: "Hata",
          text: (r && r.exceptionMessage) || "Bilinmeyen hata",
          color: "warning"
        });

        //mesajı göster;
      }
      this.value = "";
      this.editPopupActivo = false;
    },
    addTags() {
      this.popupActivo = true;
    },
    editTags(tr) {
      this.editPopupActivo = true;
      this.tagToBeEdited = tr;
    },

    show() {
      this.getCustomerTags();
    },
    created() {
      this.getCustomerTags();
    },

    getCustomerTags: async function() {
      this.customerTags = await repository
        .getAll("General/getCustomerTags")
        .then(r => r.list);

      return this.customerTags;
    }
  }
};
</script>
